import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import RegistrationHeader from './components/RegistrationHeader';
import RegistrationForm from './components/RegistrationForm';
import SocialRegistration from './components/SocialRegistration';
import RegistrationSuccess from './components/RegistrationSuccess';
import Icon from '../../components/AppIcon';


const Register = () => {
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    // Check if user is already authenticated
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate('/user-dashboard');
    }
  }, [navigate]);

  useEffect(() => {
    // Set page title
    document.title = 'Create Account - BikeUpgrade Pro';
    
    // Add meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription?.setAttribute('content', 'Join BikeUpgrade Pro to get personalized bike upgrade recommendations through AI-powered photo analysis. Create your free account today.');
    }
  }, []);

  const handleRegistrationSuccess = (email) => {
    setUserEmail(email);
    setShowSuccess(true);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20 pb-12">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl mx-auto">
            {/* Registration Header */}
            <div className="mb-8">
              <RegistrationHeader />
            </div>

            {/* Registration Form Card */}
            <div className="bg-card border border-border rounded-lg shadow-sm p-8">
              {/* Social Registration */}
              <div className="mb-8">
                <SocialRegistration />
              </div>

              {/* Main Registration Form */}
              <div>
                <RegistrationForm onSuccess={handleRegistrationSuccess} />
              </div>
            </div>

            {/* Additional Information */}
            <div className="mt-8 text-center">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
                <div className="space-y-2">
                  <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center mx-auto">
                    <Icon name="Shield" size={24} color="var(--color-accent)" />
                  </div>
                  <h3 className="font-semibold text-foreground">Secure & Private</h3>
                  <p className="text-sm text-muted-foreground">
                    Your data is encrypted and never shared with third parties
                  </p>
                </div>
                
                <div className="space-y-2">
                  <div className="w-12 h-12 bg-success/10 rounded-lg flex items-center justify-center mx-auto">
                    <Icon name="Zap" size={24} color="var(--color-success)" />
                  </div>
                  <h3 className="font-semibold text-foreground">Instant Analysis</h3>
                  <p className="text-sm text-muted-foreground">
                    Get bike upgrade recommendations in seconds
                  </p>
                </div>
                
                <div className="space-y-2">
                  <div className="w-12 h-12 bg-warning/10 rounded-lg flex items-center justify-center mx-auto">
                    <Icon name="Users" size={24} color="var(--color-warning)" />
                  </div>
                  <h3 className="font-semibold text-foreground">Community Driven</h3>
                  <p className="text-sm text-muted-foreground">
                    Join thousands of cycling enthusiasts
                  </p>
                </div>
              </div>
            </div>

            {/* Footer Links */}
            <div className="mt-12 text-center space-y-4">
              <div className="flex flex-wrap justify-center gap-6 text-sm">
                <button className="text-muted-foreground hover:text-accent transition-colors">
                  Terms of Service
                </button>
                <button className="text-muted-foreground hover:text-accent transition-colors">
                  Privacy Policy
                </button>
                <button className="text-muted-foreground hover:text-accent transition-colors">
                  Help Center
                </button>
                <button className="text-muted-foreground hover:text-accent transition-colors">
                  Contact Support
                </button>
              </div>
              
              <p className="text-xs text-muted-foreground">
                © {new Date()?.getFullYear()} BikeUpgrade Pro. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </main>
      {/* Success Modal */}
      {showSuccess && (
        <RegistrationSuccess 
          userEmail={userEmail}
          onClose={() => setShowSuccess(false)}
        />
      )}
    </div>
  );
};

export default Register;